import { c as _c } from "react/compiler-runtime";
import { type QueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { onTimezoneChange } from "@/lib/timezone";

/**
 * Invalidates `queryClient`'s queries whenever the clinic zone changes.
 * Requests carry the zone but most cache keys don't, so a location switch, an
 * override or the zone first resolving would otherwise keep serving days cut
 * on the previous clock.
 */
export function useRefetchOnTimezoneChange(queryClient) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== queryClient) {
    t0 = () => onTimezoneChange(() => void queryClient.invalidateQueries());
    t1 = [queryClient];
    $[0] = queryClient;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}